import React from 'react';
import { Link } from 'react-router-dom';
import { MoonStar } from 'lucide-react';

export const CrescentBrand = ({ compact = false, intelligence = false, testId = 'crescent-brand-home' }) => (
  <Link to="/" className={`crescent-brand ${compact ? 'compact' : ''}`} data-testid={testId} aria-label="Back to Crescent Advisory" title="Back to Crescent Advisory">
    <MoonStar size={32} strokeWidth={1.25} className="crescent-mark" aria-hidden="true" />
    {!compact && <span className="crescent-brand-copy"><strong>Crescent Advisory</strong>{intelligence && <small>Crescent Intelligence</small>}</span>}
  </Link>
);